import React, { useState } from 'react';
import logo from '../../images/logo_purple.png';
import { CustomLabel, CustomButton, CustomTextField, CustomDropdown } from "@tracknme/material-ui";
import { FormControl } from '@material-ui/core';
import '../../mobile.css';
import estadosCidades from '../../utils/estados-cidades.json';
import { phoneMask } from '../../utils/mask';
import alertMessage from '../../services/alertMessage';
import Check from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid';
import nick from '../../images/nick.png';
import { LeadsApi,UsersApi } from '../../services/Apis';

function Step1() {

    const [device, setDevices] = useState('1 - 10');
    const [state,setState] = useState('35');
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [city, setCities] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    const states = estadosCidades.states.sort(function(a,b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });

    const devices = [
            {
                value: '1 - 10',
                label: '1 - 10'
            }, {
                value: '10 - 100',
                label: '10 - 100'
            }, {
                value: '100 - 1.000',
                label: '100 - 1.000'
            }, {
                value: '1.000 - 10.000',
                label: '1.000 - 10.000'
            }, {
                value: '10.000 - 100.000',
                label: '10.000 - 100.000'
            }, {
                value: '100.000 - 500.000',
                label: '100.000 - 500.000'
            }
    ];

    var cities = estadosCidades.cities.filter(function (el) {
            return el.id <= state
    });

    cities = cities.sort(function(a,b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });

    function changeStateValue(state) {
        setState(state)
        setCities(null)
        cities = estadosCidades.cities.filter(function (el) {
            return el.id <= state
        });

        cities = cities.sort(function(a,b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
    }

    const handleChangeCityValue = (event) => {

        if (event && event.target) {
            if (event.target.outerText) {
                setCities(event.target.outerText);
            }else{
                setCities(null);
            }
        }

    }

    const handleChangeNameValue = ({target}) => {
        const {value} = target;
        setName(value);
    }

    const handleChangeEmailValue = ({target}) => {
        const {value} = target;
        setEmail(value);
    }

    function changeDevicesValue(device) {
        setDevices(device)
    }

    const handleChangePhoneNumberValue = ({target}) => {
        const {value} = target;
        let phone = phoneMask(value);
            setPhoneNumber(phone)
    }

    const validationPhoneNumber = () => {
        
        if (phoneNumber && phoneNumber.length < 15) {
            alertMessage.showErrorMessage("Telefone inválido!");
            setErrorPhoneNumber(true)
            return
        }

        setErrorPhoneNumber(false)
    }

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const checkEmail = () => {
   
        if(validateEmail(email)){
         
          UsersApi.checkLogin(email).then(response => {
    
            if(response.data === 0){
             setErrorEmail(false)
    
            }else{
              alertMessage.showErrorMessage("Esse e-mail já está em uso na plataforma!");
              setErrorEmail(true)
            }
           
            return
          }).catch(error => {
              setErrorEmail(true)
            return
          })
        }else{
          setErrorEmail(true)
          alertMessage.showErrorMessage("E-mail inválido!")
        }
    
    }
     

    const changeButtonValue = async() => {

        if (!validateEmail(email)) {
            alertMessage.showErrorMessage("E-mail inválido!")
            setErrorEmail(true)
            return
        }

        setErrorEmail(false)

        setIsDisabled(true)

        var stateSelected = estadosCidades.states.find((el) => el.value === state);

        let lead = {
            name: name,
            email: email,
            mobile: phoneNumber.replace(/\D/g, ""),
            city: city,
            state: stateSelected.sigla,
            companySize:device
        }
       
        LeadsApi
            .create(lead)
            .then(response => {
                setIsDisabled(true);
                // alertMessage.showErrorMessage('Sucesso!')
            })
            .catch((response,error) => {
                setIsDisabled(false);
                alertMessage.showErrorMessage('Serviço indisponível, tente novamente em alguns segundos...')
            });

    }


    return (
        <div className="menuMobile">
            <div className="containerMobile">
 
                <div className="containerImage" >
                    <img src={logo} className="logo" alt="Trackn'Me" />
                </div>
            
                <div className="titleAccount" >
                    <CustomLabel label="Insira seus dados para criar uma conta gratuita!" color="initial" component="h4" variant="h4" style={{fontSize:16, fontWeight:700, color:'#4D39E9'}} />  
                </div>

                <div className="textField">
                    <FormControl  >

                
                        <CustomTextField
                            label="Nome Completo:"
                            variant="filled"
                            value={name}
                            disabled={isDisabled}
                            name="name_1"
                            onChange={handleChangeNameValue}
                            placeholder="Insira seu nome"
                            style={{
                            width: '84vw'
                        }}/>

                        <CustomTextField
                            label="E-mail:"
                            variant="filled"
                            disabled={isDisabled}
                            value={email}
                            name="email_1"
                            onBlur={() => checkEmail()}  
                            onKeyPress={event => {if (event.key === 'Enter') {  checkEmail() }}}
                            onChange={handleChangeEmailValue}
                            placeholder="Insira seu e-mail comercial"
                            error={errorEmail}
                            style={{
                            width: '84vw'
                        }}/>

                        <CustomTextField
                            label="Telefone/Celular:"
                            value={phoneNumber}
                            disabled={isDisabled}
                            name="phoneNumber_1"
                            onChange={handleChangePhoneNumberValue}
                            onBlur={() => validationPhoneNumber()}
                            variant="filled"
                            placeholder="Insira seu telefone"
                            error={errorPhoneNumber}
                            inputProps={{
                                style: { fontSize: 18 },
                                autoComplete: "new-password",
                                color: "black",
                                form: {
                                  autoComplete: "off",
                                  color: "black",
                                },
                            }}
                            style={{
                                width: '84vw'
                            }}
                        /> 
        
                        <CustomDropdown
                            label="Quantidade de Rastreadores:"
                            disabled={isDisabled}
                            value={device}
                            variant="filled"
                            placeholder="Selecione seu estado"
                            currencies={devices}
                            onChange={(event) => changeDevicesValue(event.target.value)}
                            style={{
                            width: '84vw',
                            height: 46
                        }}/>

                        <CustomDropdown
                            label="Estado:"
                            disabled={isDisabled}
                            value={state}
                            variant="filled"
                            placeholder="Selecione seu estado"
                            currencies={states}
                            onChange={(event) => changeStateValue(event.target.value)}
                            style={{
                            width: '84vw',
                            height: 46
                        }}/>

                        <CustomDropdown
                            
                            name="city_1"
                            filter={true}
                            label="Cidade:"
                            disabled={isDisabled}
                            variant="filled"
                            placeholder="Selecione sua cidade"
                            value={city}
                            currencies={cities}
                            onChange={handleChangeCityValue}
                            style={{
                            width: '84vw',
                            height: 46
                        }}/> 

                        <div className="button">
                            <CustomButton
                             
                                disabled={(name  && email && city && phoneNumber && !errorPhoneNumber && !errorEmail)
                                ? false
                                : true}
                                onClick={changeButtonValue}
                                variant="contained"
                                color="secondary"
                                label="Cadastrar"
                                style={{width: '84vw',height: '45px',marginTop:10 }}
                                endIcon={< Check />}/> 
                        </div>
                        </FormControl> 
                
                    
                </div>
                {!isDisabled &&(
                    <div style={{height:100,marginTop:50}}></div>
                )}
                {isDisabled &&(
                    <div className="footerImageStep1">
                        
                        <Grid container spacing={1}>

                            <Grid item xs={9}>
                                <CustomLabel  label="Obrigado por se cadastrar!" color="initial" component="h4" variant="h4" style={{fontSize:18, fontWeight:700, color:'#4D39E9', marginTop:10, marginLeft:30}} />  
                                <CustomLabel  label="Vamos enviar um link para o seu e-mail para validar o seu cadastro." color="initial" component="h4" variant="h4" style={{fontSize:15, fontWeight:300, color:'#888888', marginTop:10, marginLeft:30}} />  
                            </Grid>
                        
                            <Grid item xs={3} >
                            <img src={nick} className="nickMobile" alt="nick" />
                            </Grid>
                        </Grid>
                        
                    </div>
                )}
                
            </div>
            
        </div>
        
    );
}

export default Step1;

